import { render } from "./8.BookCall.vue?vue&type=template&id=2ff2b2dc&scoped=true"
import script from "./8.BookCall.vue?vue&type=script&lang=js"
export * from "./8.BookCall.vue?vue&type=script&lang=js"

import "./8.BookCall.vue?vue&type=style&index=0&id=2ff2b2dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff2b2dc"]])

export default __exports__